import sameerImage from '../../../assets/images/sameer.png';
import ankanaImage from '../../../assets/images/ankana.png';
import riteshImage from '../../../assets/images/ritesh.png';
import ckImage from '../../../assets/images/ck.png';
import './growth.css';
import { Link } from 'react-router-dom';

export default function Growth(){
  const growthData = [
    {
      id: 0,
      name: "Sameer Singh",
      image: sameerImage,
      dignation: "IMS Ghaziabad’ 98",
      content: "3 decades in Retail, Real Estate and Hospitality",
      link: "#",
      inurl: "https://www.linkedin.com/in/sameerdsingh/",
    },
    {
      id: 1,
      name: "Ritesh Ghosal",
      image: riteshImage,
      dignation: "IIM Bangalore’ 95",
      content: "3 decades Building Business on Exceptional Consumer Insight",
      link: "#",
      inurl: "https://www.linkedin.com/in/ritesh-ghosal",
    },
    {
      id: 2,
      name: "C K Nageswaran",
      image: ckImage,
      dignation: "IIM Bangalore’ 95",
      content: "3 decades in Starting Up and Running Retail Businesses",
      link: "#",
      inurl: "https://www.linkedin.com/in/nageswaranck",
    },
    {
      id: 3,
      name: "Ankana Bhalla",
      image: ankanaImage,
      dignation: "Goa Institute of Management’ 2005",
      content: "2 decades of Driving Growth by Leveraging Data Backed Insights",
      link: "#",
      inurl: "https://www.linkedin.com/in/ankana-bhalla",
    },
  ];

  return (
    <section className="growth pt-3">
        <div className="growth-wrapper">
        <div className="growth-member container">
          <h4>
          We’re an eclectic bunch of data devotees and retail rebels; bringing experience, data and creativity to every challenge!
          </h4>
          <div className="row g-4">
            {growthData.map((data) => 
              <div className="col-12 col-md-6" key={data.id}>
                <div className="growthcard d-flex align-items-center position-relative">
                  <img src={data.image} alt={data.name} />
                  <Link className="position-absolute end-0" to={data.inurl} target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></Link>
                  <div className="card-body">
                    <h5>{data.name}</h5>
                    <h6>{data.dignation}</h6>
                    <p>{data.content}</p>
                    {/* <Link className="knowmore" to={data.link} target="_blank" rel="noreferrer"> Know More</Link> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        </div>
    </section>
  );
}
